/**
 * @description Delivery method, how the funds were sent to the recipient.
 */
export enum DeliveryMethodType {
  Any = "Any",
  OfficePickup = "OfficePickup",
  CashPickup = "CashPickup",
  BankDeposit = "BankDeposit",
  HomeDelivery = "HomeDelivery",
  MoneyOrder = "MoneyOrder",
  GiftCard = "GiftCard",
  RuralPickUp = "RuralPickUp",
  BillPayment = "BillPayment",
  BillPmt2 = "BillPmt2",
  BillPmtXPress = "BillPmtXPress",
  PhoneCard = "PhoneCard",
  DebitCard = "DebitCard",
  BankDepositNextDay = "BankDepositNextDay",
  AtmPickup = "AtmPickup",
  GiftVoucher = "GiftVoucher",
  MobilePayment = "MobilePayment",
  PagoMovil = "PagoMovil",
  RiaWallet = "RiaWallet",
  UPI = "UPI",
  Alipay = "Alipay",
  PIX = "PIX",
  BreB = "BreB",
  CASH_PICKUP_NUM_CODE = 1,
  BANK_DEPOSIT_NUM_CODE = 2,
  HOME_DELIVERY_NUM_CODE = 3,
  MOBILE_WALLET_NUM_CODE = 34,
  MONEY_ORDER_NUM_CODE = 4,
  GIFT_CARD_NUM_CODE = 5,
  RURAL_PICKUP_NUM_CODE = 6,
  BILL_PAYMENT_NUM_CODE = 10,
  BILL_PAYMENT2_NUM_CODE = 11,
  BILL_PAYMENT_XPRESS_NUM_CODE = 12,
  PHONE_CARD_NUM_CODE = 20,
  DEBIT_CARD_NUM_CODE = 30,
  BANK_DEPOSIT_NEXT_DAY_NUM_CODE = 31,
  ATM_PICKUP_NUM_CODE = 32,
  GIFT_VOUCHER_NUM_CODE = 33,
  UPI_NUM_CODE = 100,
  Alipay_NUM_CODE = 200,
  PIX_NUM_CODE = 300,
  BreB_NUM_CODE = 1300,
}

export const InstantDeliveryTypes = [DeliveryMethodType.PIX, DeliveryMethodType.Alipay, DeliveryMethodType.UPI, DeliveryMethodType.BreB];

export const PayAgents = {
  // agreed with Puru that the agent for Visa debit card is always 203137511 (TODO: verify in production)
  VisaDebitCard: 203137511,
}

export function mapDeepLinkDeliveryMethod(deliveryMethod: string): DeliveryMethodType {
  try {
    if (!deliveryMethod || typeof deliveryMethod !== 'string') {
      return null;
    }

    // Normalize the delivery method string: lowercase and remove underscores, hyphens, and spaces
    const normalizedInput = deliveryMethod.trim().toLowerCase().replace(/[_\-\s]/g, '');

    if (!normalizedInput) {
      return null;
    }

    // Dynamically match against enum keys (excluding numeric codes)
    const enumKeys = Object.keys(DeliveryMethodType).filter(
      key => Number.isNaN(Number(key)) && !key.includes('NUM_CODE')
    );

    // Find matching enum key by normalizing both input and enum key
    const matchedKey = enumKeys.find(
      key => key.toLowerCase().replace(/[_\-\s]/g, '') === normalizedInput
    );

    if (matchedKey) {
      const enumValue = DeliveryMethodType[matchedKey as keyof typeof DeliveryMethodType];
      if (typeof enumValue === 'string') {
        return enumValue as DeliveryMethodType;
      }
    }

    // Return null for invalid delivery methods
    return null;
  } catch (error) {
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/model/types/delivery-method-type.ts